// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { tokenStore } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent/session", { session_id });
        if (data?.access_token) tokenStore.set(data.access_token);
        setUser(data);
        // Clear hash and go to portal
        window.history.replaceState({}, document.title, "/portal");
        navigate("/portal", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF8]">
      <div className="text-center" data-testid="auth-callback">
        <div className="w-10 h-10 mx-auto mb-4 rounded-full border-2 border-[#28BBE3] border-t-transparent animate-spin" />
        <p className="text-slate-600">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
